import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
// https://www.npmjs.com/package/react-custom-google-translate

const GoogleTranslate = () => {

  // const location = useLocation();

  // useEffect(() => {
  //   if (window.google && window.google.translate) {
  //     new window.google.translate.TranslateElement(
  //       { pageLanguage: "en" },
  //       "google_translate_element"
  //     );
  //   }

  //   //the states of window.google and window.google.translate aren't the problem
  // }, [location.pathname]);

  useEffect(() => {
    const addScript = () => {
      if (document.getElementById("google-translate-script")) return;

      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en" },
          "google_translate_element"
        );
      };
    };

    addScript();
  }, []);

  return <div id="google_translate_element"></div>;
};



export default GoogleTranslate;

